import { useDispatch, useSelector } from "react-redux";
import { loadSystems, deleteSystem, resetDeleted } from "./actions";
import {
	getSystems,
	getSystemsReqInfo,
	deleteSuccess,
	getDefaultSystem,
} from "./selectors";

export function useHome() {
	const dispatch = useDispatch();

	return {
		loadObjects: () => dispatch(loadSystems()),
		delete: (system) => dispatch(deleteSystem(system)),
		resetDeleted: () => dispatch(resetDeleted()),

		systemCollection: useSelector(getSystems),
		systemCollectionReqInfo: useSelector(getSystemsReqInfo),
		defaultSystem: useSelector(getDefaultSystem),
		deleteSuccess: useSelector(deleteSuccess),
	};
}
